module.exports = __webpack_public_path__ + "img/temporal.924864b3.svg";